import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { applyGoogleSession } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) { navigate("/auth", { replace: true }); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sid });
        const u = applyGoogleSession(data);
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Welcome, ${u.name}`);
        navigate(u.role === "provider" ? "/provider" : "/dashboard", { replace: true });
      } catch (e) {
        setError("Google sign-in failed. Redirecting…");
        setTimeout(() => navigate("/auth", { replace: true }), 1600);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center text-emerald-900 font-serif text-2xl">
      {error || "Signing you in…"}
    </div>
  );
}
